import pathfinder from '@fiverr-private/pathfinder';

const SEARCH_GIGS_PATHFINDER_ROUTE = 'search_gigs';

export const buildSuggestionSearchUrl = (query: string): string =>
    pathfinder(SEARCH_GIGS_PATHFINDER_ROUTE, {}, { query: { query } });
